<template>
  <div class="edit-dialog">
    <!-- Username Input -->
    <div class="form-group">
      <label>Username</label>
      <input
        type="text"
        v-model="localUserName"
        class="form-control"
        placeholder="Edit username"
      />
    </div>

    <!-- Email Input -->
    <div class="form-group">
      <label>Email</label>
      <input
        type="email"
        v-model="localEmail"
        class="form-control"
        placeholder="Edit email"
      />
    </div>

    <!-- Role Display -->
    <div class="form-group">
      <label>Role</label>
      <input
        type="text"
        v-model="localUserType"
        class="form-control"
        disabled
      />
    </div>

    <!-- Nickname Input -->
    <div class="form-group">
      <label>Nickname</label>
      <input
        type="text"
        v-model="localNickName"
        class="form-control"
        placeholder="Edit nickname"
      />
    </div>

    <!-- Bio Input -->
    <div class="form-group">
      <label>Bio</label>
      <textarea
        v-model="localBio"
        placeholder="Edit bio"
        class="form-control"
      ></textarea>
    </div>

    <!-- Gender Input (Dropdown) -->
    <div class="form-group">
      <label>Gender</label>
      <select
        v-model="localGender"
        class="form-control"
      >
        <option value="">Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
        <option value="None">None</option>
      </select>
    </div>

    <!-- Buttons for Save and Cancel -->
    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancelChanges">
        Cancel
      </button>
      <button class="btn btn-primary" @click="saveChanges">
        Save
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userName: String,
    email: String,
    userType: String,
    nickName: String,
    bio: String,
    gender: String,
  },
  data() {
    return {
      localUserName: this.userName, // Local copies of props
      localEmail: this.email,
      localUserType: this.userType,
      localNickName: this.nickName,
      localBio: this.bio,
      localGender: this.gender,
    };
  },
  methods: {
    saveChanges() {
      const updatedUser = {
        userName: this.localUserName,
        email: this.localEmail,
        nickName: this.localNickName,
        bio: this.localBio,
        gender: this.localGender,
      };
      console.log("Emitting save event with updatedUser:", updatedUser);
      this.$emit("save", updatedUser);
    },
    cancelChanges() {
      console.log("Changes canceled");
      this.$emit("cancel"); 
    },
  },
};
</script>

<style scoped>
.edit-dialog {
  padding: 20px;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.form-group label {
  color: #f97427;
  font-weight: bold;
}

.form-control {
  padding: 8px;
  margin-bottom: 15px;
  width: 100%;
  max-width: 800px;
  border: 1px solid black;
  border-radius: 4px;
  background-color: #fedbb8;
  color: black;
}
.form-control::placeholder {
  color: white;
}

.b-modal-header .modal-title {
  color: #f97427 !important;
}

/* Override Bootstrap button styles */
.modal-footer .btn-primary {
  background-color: #f97427 !important;
  border-color: #f97427 !important;
}

.modal-footer .btn-secondary {
  color: white !important;
  background-color: #d83b3b !important;
  border-color: #d83b3b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin-only/EditUserDialog.vue